var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3348 0.694457H1.65516C1.33435 0.697014 1.02107 0.792542 0.752867 0.969599C0.484663 1.14666 0.272908 1.39773 0.142969 1.69274C0.0130305 1.98775 -0.029582 2.31418 0.0202441 2.63293C0.0700701 2.95167 0.210219 3.2492 0.423897 3.48988L5.9262 9.57406V15.3126C5.92659 15.4245 5.95804 15.534 6.01699 15.6289C6.07594 15.7237 6.16006 15.8001 6.25987 15.8495C6.34001 15.8882 6.42794 15.9077 6.51681 15.9066C6.65269 15.9077 6.78476 15.8615 6.89053 15.7757L8.00167 14.883L9.8569 13.3897C9.92597 13.3334 9.98162 13.2623 10.0197 13.1816C10.0578 13.1009 10.0774 13.0126 10.0771 12.9232V9.56735L15.5761 3.48318C15.7898 3.2425 15.9299 2.94496 15.9798 2.62622C16.0296 2.30747 15.987 1.98104 15.857 1.68603C15.7271 1.39102 15.5153 1.13995 15.2471 0.962891C14.9789 0.785834 14.6657 0.690301 14.3448 0.687744L14.3348 0.694457Z",
    fill: "#040914"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8257125dd2e37c7d767be6f5b79fcf9c.svg";
export { ForwardRef as ReactComponent };